import type { PlacementGroup } from '@/modules/adv/ad-service'
import { AppNativeSDK } from '@/modules/native-app'
import { type AdProvidersSettings, type PlatformType, type EffectiveType } from '@/types'

import { getGameDistributionAdSettings } from './game-distribution-settings'
import { getNativeAppAdSettings } from './native-app-settings'
import { getPartnerAdSettings } from './partner-integrations'
import { getPortalAdSettings } from './portal-settings'

export function getProvidersSettings({
    gamAccount,
    appNativeSDK,
    platform,
    effectiveType,
    isVersionAtLeast,
    isNativeBannersEnabled,
    gameDistributionGameId,
    clid,
    isGameDistribution,
    isExportOnWidget,
    isPartnerEmbed,
    isNativeAppEnv,
    isGoogleProvidersEnabled,
    isH5RewardedAuction,
    isPlaygamaBidderOnly,
}: {
    gamAccount: string
    appNativeSDK: AppNativeSDK | undefined
    platform: PlatformType
    effectiveType: EffectiveType | undefined
    isVersionAtLeast: (minVersions: { ios?: string; android?: string }) => boolean
    isNativeBannersEnabled: boolean
    gameDistributionGameId: string | undefined
    clid: string
    isGameDistribution: boolean
    isExportOnWidget: boolean
    isPartnerEmbed: boolean
    isNativeAppEnv: boolean
    isGoogleProvidersEnabled: boolean
    isH5RewardedAuction: boolean
    isPlaygamaBidderOnly?: boolean
}): PlacementGroup<AdProvidersSettings>[] {
    if (isGameDistribution) {
        return getGameDistributionAdSettings(gameDistributionGameId)
    }

    if (isNativeAppEnv) {
        return getNativeAppAdSettings({
            gamAccount,
            platform,
            isVersionAtLeast,
            isNativeBannersEnabled,
            appNativeSDK,
            clid,
            effectiveType,
        })
    }

    if (isPartnerEmbed) {
        return getPartnerAdSettings({
            gamAccount,
            platform,
            clid,
            effectiveType,
            isExportOnWidget,
            isGoogleProvidersEnabled,
        })
    }

    return getPortalAdSettings({
        isPlaygamaBidderOnly,
        gamAccount,
        platform,
        effectiveType,
        isH5RewardedAuction,
    })
}
